/**
 * <SectionLabel> — l'intitulé d'une section (atom typographie).
 *
 * Le style « Label » du livre : capitales espacées, 700, 11 px, encre secondaire. C'est ce que
 * portent « À FAIRE », « PROCHAINES SÉANCES », « GESTION », « FACTURATION » — un repère de
 * lecture, pas un titre. Le gros texte d'une page va à l'information (la date de la prochaine
 * séance), pas au nom du bloc qui la contient.
 *
 * Encapsulation de `<Text>`, comme `<Title>` et `<Paragraph>` : la graisse, la taille, la couleur
 * et l'interlettrage sont pinnés ici pour qu'aucun écran ne les redéclare.
 */
import React from "react"
import { type StyleProp, type TextStyle } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { type SemanticColorKey } from "../../../theme/tokens/colors"
import { Text } from "../Text"

/** Interlettrage des capitales du livre (`tracking-[.08em]` à 11 px ≈ 0,9 px). */
const LABEL_TRACKING = 0.9

export type SectionLabelProps = {
    children: React.ReactNode
    /** Encre — `text-muted` par défaut. */
    color?: SemanticColorKey
    center?: boolean
    style?: StyleProp<TextStyle>
    testID?: string
}

export function SectionLabel(props: SectionLabelProps) {
    const { children, color = "text-muted", center = false, style, testID } = props

    return (
        <Text
            testID={testID}
            size="text-xs"
            weight="bold"
            color={color}
            uppercase
            center={center}
            style={[styles.label, style]}
        >
            {children}
        </Text>
    )
}

const styles = StyleSheet.create(() => ({
    label: { letterSpacing: LABEL_TRACKING },
}))
